import { FromSchema } from '@40seas/entities/common';

import { z } from 'zod';

export const ACHPaymentMethodSchema = z.object({
    last4: z.string(),
    bankName: z.string(),
    fingerPrint: z.string(),
    routingNumber: z.string().optional(),
});

export class ACHPaymentMethod extends FromSchema(ACHPaymentMethodSchema) {
    last4: string;
    bankName: string;
    fingerPrint: string;
    routingNumber?: string;
}
